var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Copyright © 2013 - "+_vm._s(_vm.thisYear)+" simplyBrand. All Rights Reserved 沪ICP备13030473号-1")])])}
var staticRenderFns = []

export { render, staticRenderFns }